import { z } from "zod";
import { ALLOCATION_PERCENT_STEP } from "@common/constants/domains/accounting/schedules";
import {
    RecognitionAnchor,
    RecognitionMethod,
} from "@common/types/domains/accounting/schedule";

export const allocationPercentFormSchema = z
    .number({ invalid_type_error: "Enter an allocation" })
    .gt(0, "Allocation must be above 0")
    .max(100, "Allocation can't exceed 100")
    .multipleOf(
        ALLOCATION_PERCENT_STEP,
        "Allocation supports up to 2 decimal places",
    );

export const scheduleComponentRowFormSchema = z.object({
    key: z.string(),
    method: z.nativeEnum(RecognitionMethod),
    anchor: z.nativeEnum(RecognitionAnchor),
    offsetDays: z.number().int().min(-3650).max(3650),
    allocationPercent: allocationPercentFormSchema,
});
